export default {
    'name': 'delimiter-big',
    'width': '48',
    'height': '48',
    'viewBox': '0 0 48 48',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M25 40L25 8L24 8L24 40L25 40Z\' fill=\'#026958\'/>'
}
